import React from "react";
import { motion } from "framer-motion";

export default function TheHaven() {
  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section
        className="relative h-[60vh] bg-cover bg-center flex items-center justify-center"
        style={{ backgroundImage: "url('/thehavern.jpg')" }}
      >
        <div className="absolute inset-0 bg-black/50" />
        <motion.div
          className="relative z-10 text-center text-white px-6"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-4xl md:text-5xl font-extrabold mb-4">The Haven</h1>
          <p className="text-lg max-w-2xl mx-auto">
            A private sanctuary that combines elegant living with the tranquility of Aspen’s natural surroundings.
          </p>
        </motion.div>
      </section>

      {/* Overview */}
      <div className="max-w-6xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-12">
        <div>
          <h2 className="text-2xl font-bold mb-4">Overview</h2>
          <p className="text-gray-700 leading-relaxed">
            The Haven is crafted for those who seek exclusivity and peace. Designed with open layouts, lush greenery,
            and premium finishes, it embodies Aspen Plush Homes’ philosophy of timeless luxury.
          </p>
          <ul className="mt-6 space-y-2 text-gray-600">
            <li><b>Property Type:</b> Villas</li>
            <li><b>Location:</b> Ashongman</li>
            <li><b>Status:</b> Near Completion</li>
            <li><b>Price:</b> USD 330,000</li>
          </ul>
        </div>
        <div className="bg-gray-100 rounded-lg shadow-md p-6">
          <h3 className="text-lg font-semibold mb-3">Key Features</h3>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>4 bedrooms fully furnished or unfurnished</li>
            <li>5 washrooms</li>
            <li>1 family area</li>
            <li>Walk-in closet</li>
            <li>Modern kitchen with premium appliances</li>
            <li>Private terraces with scenic views</li>
            <li>CCTV surveillance</li>
            <li>Energy-efficient systems</li>
            <li>Smart home technology</li>
            <li>Secure gated home</li>
            <li>Ample parking space</li>
            <li>Proximity to key amenities and transport links</li>            
            <li>Expansive living and dining spaces</li>
            <li>Eco-friendly building solutions</li>
          </ul>
        </div>
      </div>

      {/* Gallery */}
      <div className="max-w-6xl mx-auto px-6 py-16">
        <h2 className="text-2xl font-bold mb-6">Gallery</h2>
        <div className="grid md:grid-cols-3 gap-6">
          <img src="/thehavern.jpg" alt="The Haven 1" className="rounded-lg shadow-md" />
          <img src="/thehavern.jpg" alt="The Haven 2" className="rounded-lg shadow-md" />
          <img src="/thehavern.jpg" alt="The Haven 3" className="rounded-lg shadow-md" />
          <img src="/haven.jpeg" alt="The Haven 4" className="rounded-lg shadow-md" />
          <img src="/haven2.jpeg" alt="The Haven 6" className="rounded-lg shadow-md" />
          <img src="/haven3.jpeg" alt="The Haven 7" className="rounded-lg shadow-md" />
          <img src="/haven4.jpeg" alt="The Haven 8" className="rounded-lg shadow-md" />
          <img src="/haven5.jpeg" alt="The Haven 9" className="rounded-lg shadow-md" />
          <img src="/haven6.jpeg" alt="The Haven 10" className="rounded-lg shadow-md" />
          <img src="/haven7.jpeg" alt="The Haven 11" className="rounded-lg shadow-md" />
          <img src="/haven8.jpeg" alt="The Haven 12" className="rounded-lg shadow-md" />
          <img src="/haven9.jpeg" alt="The Haven 13" className="rounded-lg shadow-md" />
        </div>
      </div>

      {/* Contact CTA */}
      <div className="bg-indigo-600 text-white text-center py-12">
        <h2 className="text-3xl font-bold mb-4">Interested in The Haven?</h2>
        <p className="mb-6">Book a tour and discover your future home today.</p>
        <a
          href="/contact"
          className="bg-white text-indigo-600 px-6 py-3 rounded-lg font-semibold shadow hover:bg-gray-100"
        >
          Get in Touch
        </a>
      </div>
    </div>
  );
}
